import { useState, useEffect } from 'react';
import { newsAPI } from '@/services/api';
import type { NewsArticle } from '@/services/api';

export { type NewsArticle };

export function useMarketNews(limit = 20, refreshInterval = 300_000) {
  const [articles, setArticles] = useState<NewsArticle[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let mounted = true;

    async function fetchNews() {
      try {
        const data = await newsAPI.getRecent(limit);
        if (mounted) {
          setArticles(data);
          setError(false);
        }
      } catch {
        if (mounted) setError(true);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchNews();
    const id = setInterval(fetchNews, refreshInterval);
    return () => { mounted = false; clearInterval(id); };
  }, [limit, refreshInterval]);

  return { articles, loading, error };
}
